import React from 'react';
import { Navigate } from 'react-router-dom';
import { getToken } from '../authStorage';

export default function PrivateRoute({ children }) {
  if (!getToken()) {
    return <Navigate to="/login" replace />;
  }
  return children;
}
